<template>
  <div>
    <div class="">
      <div class="container">
        <div class="mt-2">
          <div class="row">
            <div class="mt-4 col-md-6 mx-auto">
              <div><reset-password :token="$route.params.token" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ResetPassword from "@/components/ResetPassword";
export default {
  components: {
    ResetPassword
  },
  data: function() {
    return {};
  },
  metaInfo: {
    title: "Reset Password"
  }
};
</script>
<style></style>
